import Cookies from "js-cookie";
import { API_URL } from "lib/constants";
import useWsSender from "lib/wsSenderHook";
import { sendGetHttpRequest, sendHttpRequest } from "lib/fetcher";
export function useAutomationService() {
  const { sendWsRequest } = useWsSender();

  async function sendUpdateCameraRuleRequest(cameras, orgId) {
    return sendWsRequest(
      "alert.update_camera_alert_rules",
      {
        alertUpdateCameraRule: {
          data: cameras,
        },
      },
      { orgId, timeout: 35000 },
    );
  }

  async function getAdvancedAISetting(orgId, id: number) {
    try {
      const data = await sendGetHttpRequest(
        `/alert/settings/camera/${id}`,
        orgId,
      );
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function updateAdvancedAISetting(data, id: number, orgId: number) {
    return await sendHttpRequest({
      method: "put",
      url: `/alert/settings/camera/${id}`,
      data: data,
      headers: {
        "x-org-id": orgId,
      },
    });
  }

  return {
    sendUpdateCameraRuleRequest,
    getAdvancedAISetting,
    updateAdvancedAISetting,
  };
}
export function generateVgInstruction(
  courtesy,
  messageIntention,
  triggerCondition,
) {
  return sendHttpRequest({
    method: "post",
    url: `/openai/gen_vg_custom_prompt`,
    data: {
      customPromptCfg: {
        courtesy,
        messageIntention,
        triggerCondition,
      },
    },
  });
}
